import getEnvironment from "../getEnvironment";
import { MappedFacetList, FacetListDTO } from "./filters.type";
import { mapFacetList } from "./mapFacetList";

const getFacetList = async (
  url: string,
  authToken: string,
  isToUseAuthZero: boolean
): Promise<MappedFacetList | any> => {
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  }

  if (getEnvironment() === "localhost" && !isToUseAuthZero) {
    if (!process.env.TOKEN) {
      console.log("TOKEN variable not set.");
    }

    headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
  }

  let res: Response | undefined;

  try {
    res = await fetch(url, {
      method: "GET",
      headers,
    });

    if (!res.ok) {
      throw new Error(
        `An error (${res.status}) occurred while fetching the data.`
      );
    }

    const result: FacetListDTO = await res.json();
    return mapFacetList(result);
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export default getFacetList;
